import { createContext } from 'react';

import type { ConsentContextValue } from '../ui/ConsentProvider';

/**
 * Контекст согласия отдельным файлом от провайдера.
 *
 * Причина техническая: файл с компонентом обязан экспортировать только
 * компоненты, иначе ломается Fast Refresh и правило `react-refresh`. Причина
 * содержательная та же — контекст переживает перерисовку провайдера, и держать
 * его рядом с ним значит пересоздавать при каждом изменении файла.
 */
export const ConsentContext = createContext<ConsentContextValue | null>(null);
